<template> 
  <div class='px-3 py-3 mb-5 col-24 col-md-11'>
    <div class='col d-column'>
      <h1 class="title pt-2 mb-0" v-text="$ml.get('access')">Acessos</h1>
      <h1 class="title"><span v-text="$ml.get('accountAcSubTitle')" class="pb-2"></span></h1>  
 
      <div class='card mb-3'>
        <div class='card-header'>
          <h6 class='m-0 p-0 light' v-text="$ml.get('historic')">Histórico</h6>
        </div> 
        <div class='card-body p-0'>
          <table> 
            <tbody>
              <tr v-show="loading" class="loading"> 
                <div class="c-loader m-3"></div> 
               </tr> 
              <tr v-for="(item, index) in itensSessions" :key="index">
                <td class='col-2 justify-content-center d-flex align-items-start'> 
                  <svg width="20" height="20" class="mt-1">       
                    <image xlink:href="../../../src/assets/icons/tv.svg" width="20" height="20"/>    
                  </svg>
                </td>
                <td class='col-22'>
                  <p class="mb-0"><strong>IP address: <font v-text="item.ip"></font></strong><br />
                    <!-- User agent: <font v-text="item.browser_agent"></font><br /> -->
                    Location: <font v-if="item.location.country" v-text="item.location.country+'-'+item.location.region+'-'+item.location.city"></font><br />
                    Signed in: <font v-text="item.createdAt"></font><br /> 
                  </p>
                </td> 
              </tr>  
            </tbody> 
          </table> 
        </div> 
      </div> 
    </div> 
  </div> 
</template>

<script>
import AccountService from "../../services/account.service";

export default { 
  data() {
    return {
      itensSessions: [], 
      loading: true,
    };
  },
  mounted() { 
    this.changeSessions(); 
  },
  methods: {
    changeSessions() {
      this.loading= true;

      AccountService.getAuditSessions()
        .then((response) => { 
          this.loading = false;
          this.itensSessions = response.data;
        },
        () => { 
          this.loading = false;
        }
      );
       
    },
  },
};
</script>
 